
<template>
  <div v-wechat-title="titleTp">
    <TopBar :pagetitle="title" :back-url="backurl" />
    <van-uploader
      v-if="!code"
      v-model="fileList"
      class="imageUpload"
      multiple
      :max-count="1"
    />
    <van-button v-if="!code" type="info" size="large" :loading="buttonLoading" :color="GetColorMain()" @click="onComment">提交分享截图</van-button>
    <div v-if="!code" class="about">请上传参加活动要求分享到朋友圈或者其他潜水群的截图，如您上传的截图与之无关我们将会取消您的领奖资格。</div>
    <div v-if="code" class="codeArea">领奖代码<div>{{ code }}</div></div>
    <van-button v-if="code" type="info" size="large" :color="GetColorMain()" @click="onGotoGet">我已复制好代码现在去领奖</van-button>
    <div v-if="code" class="about"> 领取成功,如您上传的分享图不符合，我们将会取消您的领奖资格。请复制领奖码后领取</div>

  </div>
</template>
<script>
import request from '@/utils/request'
import { Button, Uploader } from 'vant'
import TopBar from '@/components/TopBar'
import { MyNotify, compressorImageList } from '@/utils/base'
import { GetColorMainBack, GetColorMain, GetColorSecondary, GetSysTitle, GetColorMainLine } from '@/utils/base'
export default {
  components: {
    [Button.name]: Button,
    [Uploader.name]: Uploader,
    TopBar
  },
  data() {
    return {
      titleTp: '酷潜量贩店',
      buttonLoading: false,
      title: '跟屁虫领取',
      backurl: '/home/index',
      fileList: [],
      code: undefined,
      imgdata: undefined
    }
  },

  created() {
    this.titleTp = GetSysTitle()
  },
  methods: {
    GetColorMainLine,
    GetColorMainBack,
    GetColorMain,
    GetColorSecondary,
    GetSysTitle,
    onGotoGet() {
      this.$router.push('/group/group/genpichong')
    },
    uploadImg(callback) {
      var noFile = true
      var fileList = []
      this.fileList.map((value, index, array) => {
        if (value.file) {
          fileList.push(value.file)
          noFile = false
        }
      })
      if (noFile) {
        if (callback) {
          callback()
        }
        return
      }
      compressorImageList(fileList, 1024, 1024, 0.6, (list) => {
        const formData = new FormData()
        list.map((value, index, array) => {
          if (value.name) {
            formData.append('file', value.file, value.name)
          } else {
            formData.append('file', value.file)
          }
        })
        request({
          url: '/Data/uploadFile?config=activitygpc',
          method: 'post',
          data: formData
        }).then(response => {
          console.log('上传图片反馈', response)
          if (!response.success) {
            this.buttonLoading = false
            return
          }
          var list = []
          response.data.map((value, index, array) => {
            list.push(value.save)
          })
          this.imgdata = list[0]
          if (callback) {
            callback()
          }
        })
      })
    },
    onComment() {
      if (this.fileList.length <= 0) {
        MyNotify('info', '请上传分享截图', 3000)
        return
      }
      this.buttonLoading = true
      this.uploadImg(() => {
        // 上传数据
        request({
          url: '/data/getActivitygpc',
          method: 'post',
          params: { url: this.imgdata }
        }).then(response => {
          this.buttonLoading = false
          if (!response.success) {
            return
          }
          this.code = response.data
          MyNotify('success', '领取成功,如您上传的分享图不符合，我们将会取消您的领奖资格。请复制领奖码后领取', 3000)
        })
      })
    }
  }
}
</script>
<style scoped>
.codeArea{
    text-align: center;
    padding: 4em 0;
}
.codeArea div{
    padding: 0.5em 0;
    font-size: 2em;
}
.about{
    text-align: center;
}
</style>
